import ScalarDropdownDivider_default from "../ScalarDropdown/ScalarDropdownDivider.vue.js";
import { Fragment, createElementBlock, createVNode, defineComponent, openBlock, renderSlot, unref } from "vue";
var ScalarMenuSection_vue_vue_type_script_setup_true_lang_default = /*@__PURE__*/ defineComponent({
	inheritAttrs: false,
	__name: "ScalarMenuSection",
	setup(__props) {
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock(Fragment, null, [createVNode(unref(ScalarDropdownDivider_default)), renderSlot(_ctx.$slots, "default")], 64);
		};
	}
});
//#endregion
export { ScalarMenuSection_vue_vue_type_script_setup_true_lang_default as default };

//# sourceMappingURL=ScalarMenuSection.vue_vue_type_script_setup_true_lang.js.map